import actions from "./actions";
import endpoints from "../api/endpoints";

const {
  doVideoListRequest,
  doVideoListSuccess,
  doVideoListFailure,
  doVideoListAdd,
} = actions;

const fetchVideoList =
  (params, isAdding = false) =>
  (dispatch) => {
    dispatch(doVideoListRequest());
    $.ajax({
      method: "get",
      url: endpoints.videoList,
      data: params,
      success(data, statusText, { status }) {
        if (isAdding) {
          dispatch(doVideoListAdd(data ? data.videos || [] : []));
        } else {
          dispatch(
            doVideoListSuccess({
              data: data ? data.videos || [] : [],
              statusText,
              status,
            })
          );
        }
      },
      error(xhr) {
        dispatch(doVideoListFailure(xhr));
      },
    });
  };

export default {
  fetchVideoList,
};
